<template>
  <transition name="dialog-fade">
    <div class="backBox">
      <div class="backContent">
       <div class="tipsBox">
         <span class="warring"></span>
         <span>确认退出登录吗？</span>
       </div>
        <div class="btnBox">
          <div @click="handleCancel">取消</div>
          <div @click="handleSubmit">确认</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { clearLoginData } from '@/api/indexPage'
  import {eventBus} from '@/utils/eventBus'
  import Cookies from 'js-cookie'
  export default {
    props: {
      backType: {
        type: String
      }
    },
    methods: {
      handleCancel() {
        this.$parent.handleCancel()
      },
      async handleSubmit() {
        try {
          const res = await clearLoginData()
          if(res.apiStatus) {
           switch (this.backType) {
             case '1':
               eventBus.$emit('openLoginDialog',true) // 向newHeader组件进行传值
               this.$parent.handleCancel()
                   break
             case '2':
               eventBus.$emit('openLoginDialog1',true) // 向indexPage组件进行传值
               this.$parent.handleCancel()
                   break
             case '3':
               eventBus.$emit('openLoginDialog3',true) // 向indexPage组件进行传值
               this.$parent.handleCancel()
                   break
             case '4':
               eventBus.$emit('openLoginDialog4',true) // 向indexPage组件进行传值
               this.$parent.handleCancel()
                   break
             case '0':
               eventBus.$emit('changeNum',true) // 向newHeader组件进行传值

               this.$router.push({
                 path: '/',

               },)
               this.handleCancel()
               this.$parent.isPortraitFlag = false
                   break
               case '5':
                   this.$store.commit('delivery/switchLoginStatus', true);
                   this.$store.commit('delivery/switchState', false);
                   this.$parent.handleCancel()
                   break
               case '6':
                   this.$store.commit('collect/switchLoginStatus', true);
                   this.$store.commit('collect/switchState', false);
                   this.$parent.handleCancel()
                   break
           }
            Cookies.remove('user_id')
            Cookies.remove('com_key_user')
            Cookies.remove('login_type')
            Cookies.remove('resume_data')
            sessionStorage.removeItem('studentInfo')
            sessionStorage.removeItem('resume_data')
            sessionStorage.removeItem('wantpoidata')
          }
        }catch (e) {
          this.$Message.error('接口调用失败')
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .backBox {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 12;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,.4);
    .backContent {
      width: 336px;
      background-color: #FFFFFF;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      padding: 24px 16px 16px 24px;
      box-sizing: border-box;
      .tipsBox {
        display: flex;
        align-items: center;
        .warring {
          display: inline-block;
          width: 23px;
          height: 22px;
          background: url(../../assets/icon_warring.png) no-repeat center center;
          background-size: 100%;
          margin-right: 16px;
        }
        span:last-child {
          display: inline-block;
          font-size: 16px;
          color: #17233D;
        }
      }
      .btnBox {
        display: flex;
        justify-content: flex-end;
        margin-top: 32px;
        div {
          width: 64px;
          height: 32px;
          border-radius: 2px;
          border: 1px solid #D9D9D9;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
          font-size: 14px;
          color: #17233D;
          border-radius: 4px;
          &:hover {
            cursor: pointer;
          }
        }
        div:last-child {
          color: #FFFFFF;
          background-color: @color-btn-background;
          margin-right: 0;
          border: none;
        }
        div:hover {
          border-color: @color-btn-hover;
          color: @color-font-size-hover;
        }
        div:active {
          color: @color-btn-active;
          border-color: @color-btn-active;
        }
        div:last-child:hover {
          cursor: pointer;
          color: #FFFFFF;
          background-color: @color-btn-hover;
        }
        div:last-child:active {
          cursor: pointer;
          color: #FFFFFF;
          background-color: @color-btn-active;
        }
      }
    }
  }
  // 进入动画
  .dialog-fade-enter-active {
    animation: dialog-fade-in 0.4s;
  }
  // 离开动画
  .dialog-fade-leave-active {
    animation: dialog-fade-out 0.4s;
  }

  @keyframes dialog-fade-in {
    0% {
      transform: translate3d(0, -20px, 0);
      opacity: 0;
    }
    100% {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }

  @keyframes dialog-fade-out {
    0% {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
    100% {
      transform: translate3d(0, -20px, 0);
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/backLoginDialog.vue